module.exports = __webpack_public_path__ + "static/media/location-maps-letter-b-arrow.0a8333cf.png";